import React from "react"
import type { State } from "@hookstate/core";
import { FormHelperText, Grid } from "@mui/material"
import FilterAutocompleteFetch from "~/components/FilterAutocompleteFetch"
import { InputSearchWithClear } from "~/components/InputSearchWithClear"
import type IDevice from "~/features/Device/interfaces/IDevice";
import { useLang } from "~/hooks/useLang";
import type { CheckAvailabilityResponse, DisabledNextButton } from "../../interfaces";

interface AssociateDeviceProps {
  readonly device: State<IDevice | null>;
  readonly task: State<string | null>;
  readonly resetValues: State<boolean>;
  readonly focusChange: State<boolean>;
  readonly endDate: State<string | null>;
  readonly activeStep: State<number>;
  readonly disabledNextButton: State<DisabledNextButton>;
  readonly checkAvailabilityResult?: State<CheckAvailabilityResponse | null>;
  readonly disabledFields?: boolean;
  readonly loading?: boolean;
}

export default function AssociateDevice({ device, task, resetValues, focusChange, checkAvailabilityResult, activeStep, disabledFields, loading }: AssociateDeviceProps) {
  const { translate } = useLang();


  return (
    <>
      <Grid container xs={12} spacing={2}>
        <Grid item xs={2} >
          <FilterAutocompleteFetch
            model="device"
            label={'device'}
            urlFetch={'/device/find'}
            size={"small"}
            disabled={disabledFields}
            dataRequest={'device'}
            paramsPayload={{ dispatch_groups_from_station: true }}
            getFullObject={device}
            resetValues={resetValues.get()}
            valueId={device.get()?.id}
            focusChange={focusChange}
            error={activeStep.get() === 1 ? Boolean(checkAvailabilityResult?.get()?.error) : false}
          />
        </Grid>
        <Grid item xs={2}>
          <InputSearchWithClear
            search={task as State<string>}
            placeholder={translate('Task')}
            sx={{ width: '100%', height: '100%' }}
            disabled={disabledFields}
            loading={loading}
          />
        </Grid>
      </Grid>
      {Boolean(checkAvailabilityResult?.get()?.error) && activeStep.get() === 1 && (
        <FormHelperText error={Boolean(checkAvailabilityResult?.get()?.error)}>
          {checkAvailabilityResult?.get()?.error}
        </FormHelperText>
      )}
    </>
  )
}